<template>
  <div class="parent-row">
    <div class="parent-row__avatar">
      <img
        v-if="member.avatar"
        class="parent-row__avatar-img"
        :src="member.avatar"
        alt=""
      >
      <span
        v-else
        class="parent-row__initials"
      >{{ initials }}</span>
    </div>

    <div class="parent-row__info">
      <h3 class="parent-row__name">
        {{ member.full_name }}
        <span
          v-if="isCurrentUser"
          class="parent-row__you-badge"
        >You</span>
      </h3>
      <p class="parent-row__email">{{ member.email }}</p>
    </div>
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils'

export default {
  name: 'ParentRow',
  props: {
    member: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isCurrentUser() {
      const user = getUserData()
      return user && user.id === this.member.id
    },
    initials() {
      const name = this.member.full_name || ''
      return name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part[0].toUpperCase())
        .join('')
    },
  },
}
</script>

<style scoped>

</style>

